<!-- 开发票弹框 -->
<template>
    <el-dialog @close="close" append-to-body :visible.sync="dialogVisible" width="90%">
        <div class="container">
            <div class="lineBox">
                <div class="lineBoxTitle">
                    <div class="fengGe"></div>
                    <p class="p1">开票说明</p>
                    <p class="p2">该订单由麦格仕(或其分公司)开发票</p>
                </div>
                <p class="lineBoxP1"><span class="lineBoxSpan1">*</span>可发票金额 <span class="lineBoxSpan2">不包含礼品卡 优惠劵
                        积分抵扣</span> 支付的部分</p>
                <p class="lineBoxP1"><span class="lineBoxSpan1">*</span>该房费发票由麦格仕(或其分公司)开具。保险发票由保险公司开具并在离店后 7个工作日左右寄达给您。
                </p>
                <p class="lineBoxP1"><span class="lineBoxSpan1">*</span>您的订单包含附加产品时，订单升级为旅游套餐订单，开票内容统一为"旅游服务 旅游服务费"。</p>
            </div>
            <div class="lineBox" style="margin-bottom: 0.7rem;">
                <div class="lineBoxTitle">
                    <div class="fengGe"></div>
                    <p class="p1">可以开具哪些类型的发票？</p>
                    <p class="p2">发票类型及介绍</p>
                </div>
                <div class="invoice" v-for="(item, keys) in invoiceTypeObj" :key="keys">
                    <div :style="item.sty" class="invoiceBox" v-for="(n, m) in item.lineList" :key="m">
                        {{ n }}
                    </div>
                </div>
            </div>
            <div class="lineBox">
                <div class="lineBoxTitle">
                    <div class="fengGe"></div>
                    <p class="p1">发票信息</p>
                    <p class="p3"
                        @click="current = item, ruleForm.invoicingKind = index, ruleForm.invoicingType = 0, invoiceTypeSW()"
                        :class="current === item ? 'active' : ''" v-for="(item, index) in invoiceInfoBtn" :key="item">{{
                            item
                        }}</p>
                </div>
                <el-card class="box-card">
                    <div style="margin-bottom: 10px;display: flex;align-items: center;">
                        <div style="font-size: 20px;font-weight: bold;color: red;">开票金额：{{ current ==
                            '合并开票' ? allOrderPrice : spreadDatas.payPrice }}¥
                        </div>
                        <span v-if="tableData.length" @click="selectInvoiceInfo"
                            style="margin-left: 0.2rem;font-size: 0.17rem;cursor: pointer;text-decoration: underline;color: #CB582E;">选择已有数据</span>
                    </div>
                    <div class="cardLine">
                        <p class="cardLineP1"><span>*</span>发票类型：</p>
                        <div @click="ruleForm.invoicingType = item.code"
                            :class="ruleForm.invoicingType == item.code ? 'active1' : ''" class="infoBox"
                            v-for="(item, index) in cardLineBtn" :key="index">
                            <p>{{ item.name }}</p>
                            <p>{{ item.name1 }}</p>
                        </div>
                    </div>
                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="90px" class="demo-ruleForm">
                        <el-form-item label="发票方:" prop="invoicingPartyName">
                            <el-input disabled placeholder="请输入内容" style="width: 2.4rem;" size="small"
                                v-model="ruleForm.invoicingPartyName"></el-input>
                        </el-form-item>
                        <!-- <el-form-item label="发票内容:" prop="invoicingContent">
                            <el-input placeholder="请输入内容" style="width: 2.4rem;" size="small"
                                v-model="ruleForm.invoicingContent"></el-input>
                        </el-form-item> -->
                        <div style="display: flex;align-items: center;"
                            v-for="(item, index) in ruleForm.invoicingDetailList" :key="index">
                            <el-form-item label="发票内容:" required>
                                <el-form-item prop="lookUp">
                                    <el-input placeholder="请输入发票内容" style="width: 2.4rem;" size="small"
                                        v-model="item.remark"></el-input>
                                </el-form-item>
                            </el-form-item>
                            <el-form-item label="发票类型:" required>
                                <el-form-item prop="type">
                                    <el-select style="width: 2.5rem;" size="small" v-model="item.type"
                                        placeholder="请选择">
                                        <el-option v-for="item in options" :key="item.value" :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select> </el-form-item>
                            </el-form-item>
                            <el-form-item label="发票抬头:" required>
                                <el-form-item prop="lookUp">
                                    <el-input placeholder="公司名称" style="width: 2.4rem;" size="small"
                                        v-model="item.lookUp"></el-input>
                                </el-form-item>
                            </el-form-item>
                            <el-form-item label="税号:" required>
                                <div style="display: flex;align-items: center;">
                                    <el-input placeholder="纳税人识别号" style="width: 2.4rem;margin-right: 0.08rem;"
                                        size="small" v-model="item.duty"></el-input>
                                    <!-- <el-tooltip placement="top" effect="light">
                                        <div slot="content">开具企业抬头发票须正
                                            <br />确填写纳税人识别号，
                                            <br />以免影响报销
                                        </div>
                                        <i style="font-size: 0.2rem;color: rgb(221, 88, 39);"
                                            class="el-icon-warning"></i>
                                    </el-tooltip> -->
                                </div>
                            </el-form-item>
                            <span style="margin-left: 0.1rem;color: red;margin-bottom: 0.22rem;">分项金额:{{
                                Number(item.price) }}¥</span>
                        </div>
                        <div style="display: flex;align-items: center;">
                            <el-form-item label="邮箱地址:" prop="email">
                                <el-input placeholder="邮箱地址" style="width: 2.4rem;" size="small"
                                    v-model="ruleForm.email"></el-input>
                            </el-form-item>
                            <el-form-item label="地址:">
                                <el-input placeholder="请输入地址" style="width: 2.4rem;" size="small"
                                    v-model="ruleForm.address"></el-input>
                            </el-form-item>
                            <el-form-item label="电话:">
                                <el-input placeholder="请输入电话" style="width: 2.4rem;" size="small"
                                    v-model="ruleForm.telephone"></el-input>
                            </el-form-item>
                        </div>
                        <div style="display: flex;align-items: center;">
                            <el-form-item label="开户行:">
                                <el-input placeholder="请输入开户行" style="width: 2.4rem;" size="small"
                                    v-model="ruleForm.openingBank"></el-input>
                            </el-form-item>
                            <el-form-item label="账号:">
                                <el-input placeholder="请输入账号" style="width: 2.4rem;" size="small"
                                    v-model="ruleForm.openingBankAccount"></el-input>
                            </el-form-item>
                            <el-form-item label="发票备注:">
                                <el-input placeholder="发票注明酒店名和入离日期" style="width: 2.4rem;" size="small"
                                    v-model="ruleForm.invoicingRemark"></el-input>
                            </el-form-item>
                        </div>
                        <div class="cardLine" v-if="current == '合并开票'">
                            <p class="cardLineP1" style="width: 1.5rem;margin-right: 0.2rem;">
                                <span>*</span>同张发票，含 <span style="color: red;">{{
                                    ruleForm.invoicingOrderPriceRequests.length }}</span> 个订单
                            </p>
                            <p class="cardLineP2" @click="handlerSelectOrderClick">修 改</p>
                        </div>
                        <div class="cardLine" v-if="current == '拆分开票'"
                            style="display: inline-flex;flex-direction: column;">
                            <div style="display: flex">
                                <p class="cardLineP1" style="width: 1.5rem;margin-right: 0.2rem;">
                                    <span>*</span>设置开票数量：<span style="color: red;">{{
                                        this.ruleForm.invoicingDetailList.length }}</span>张
                                </p>
                                <p @click="handlerSetOrderInvoiceClick" class="cardLineP2">设 置</p>
                            </div>

                            <div style="display: flex;margin-top: 3px;margin-left: 2px">
                                <p class="cardLineP1" style="width: 1.5rem;margin-right: 0.2rem;">
                                    <span>*</span>同张发票，含 <span style="color: red;">{{
                                        ruleForm.invoicingOrderPriceRequests.length }}</span>
                                    个订单
                                </p>
                                <p class="cardLineP2" @click="handlerSelectOrderClick">修 改</p>
                            </div>

                        </div>
                        <el-form-item v-if="ruleForm.invoicingType != 0" label="收票人信息:" required>
                            <el-form-item>
                                <span @click="addressFilling"
                                    style=" cursor: pointer;text-decoration: underline;margin-right: 0.2rem;">添加新地址</span>
                                <span @click="selectAddress"
                                    style=" cursor: pointer;text-decoration: underline;">选择已有地址</span>
                            </el-form-item>
                        </el-form-item>
                        <el-card v-if="JSON.stringify(addressInfo) !== '{}' && ruleForm.invoicingType != 0"
                            style="margin-bottom: 0.15rem;width: 4rem;">
                            <div slot="header" class="clearfix">
                                <span>收件人详细信息</span>
                            </div>
                            <ul class="addressInfoBox">
                                <li>
                                    <p>姓名：</p>{{ addressInfo.userName }}
                                </li>
                                <li>
                                    <p>手机号码：</p>{{ addressInfo.userPhone }}
                                </li>
                                <li>
                                    <p>收货地址：</p>{{ addressInfo.address }}
                                </li>
                            </ul>
                        </el-card>
                        <!-- <div class="cardLine" v-if="ruleForm.invoicingType != 0">
                            <p class="cardLineP1" style="margin-right: 0.2rem;padding-right: 0.12rem;"><span>*</span>配送方式:
                            </p>
                            <div class="priceBtn">
                                <span class="priceBtnSpan1">快递</span>
                                <span class="priceBtnSpan2">2000积分</span>
                            </div>
                            <div class="priceBtn">
                                <span class="priceBtnSpan1">快递</span>
                                <span class="priceBtnSpan2">10¥</span>
                            </div>
                        </div> -->
                        <el-form-item>
                            <el-button type="primary" @click="submitForm('ruleForm')">保存发票信息</el-button>
                        </el-form-item>
                    </el-form>
                </el-card>
            </div>
        </div>
        <orderSelectList :defaultGou="spreadDatas.orderMainId" @orderClick="orderClick" ref="orderSelectList">
        </orderSelectList>
        <collectionSelectList :defaultGou="spreadDatas.orderMainId" @orderClick="orderClick" ref="collectionSelectList">
        </collectionSelectList>
        <setInvoicePopup :planId="planId" :tableData="tableData"  @setInvoiceClick="setInvoiceClick" ref="setInvoicePopup"></setInvoicePopup>
        <ticketRecipientInformationPopup @addressInfoClick="addressInfoClick" ref="ticketRecipientInfo">
        </ticketRecipientInformationPopup>
        <existingAddressPopup @addressInfoClick="addressInfoClick" ref="existingAddressPopup"></existingAddressPopup>
        <thereIsAlreadyAnInvoicePopUpBox :tableData="tableData" :planId="planId" @selectInvoice="selectInvoice"
            ref="thereIsAlreadyAnInvoicePopUpBox">
        </thereIsAlreadyAnInvoicePopUpBox>
    </el-dialog>
</template> 

<script>
import orderSelectList from './orderSelectList.vue'
import setInvoicePopup from './setInvoicePopup.vue'
import collectionSelectList from './collectionSelectList.vue'
import ticketRecipientInformationPopup from './ticketRecipientInformationPopup.vue'
import existingAddressPopup from './existingAddressPopup.vue'
import Api from '@/components/Api/index'
import thereIsAlreadyAnInvoicePopUpBox from './thereIsAlreadyAnInvoicePopUpBox.vue'
export default {
    components: {
        orderSelectList,
        setInvoicePopup,
        ticketRecipientInformationPopup,
        existingAddressPopup,
        collectionSelectList,
        thereIsAlreadyAnInvoicePopUpBox
    },
    props: {
        state: {
            default: 0, //0客户订单，1收款订单
        },
        orderList: {
            type: Array,
            default: () => []
        },
        detailId: {

        }
    },
    data() {
        return {
            isSubmitting: false, // 添加防重复提交标志
            allOrderPrice: 0,//订单合并的总价格
            companyInfo: null,//公司信息
            addressInfo: {},//收件人信息
            planId: null,
            tableData:[],
            ruleForm: {
                "email": "",
                "id": null,
                "invoicingContent": "",
                "invoicingDetailList": [],
                "invoicingPartyId": null,
                "invoicingPartyName": "表格仕国际旅行社（北京） 有限公司",
                "invoicingRemark": "",
                "invoicingType": 0,
                "orderIds": [],
                "invoicingOrderPriceRequests": [],
                "userAddressId": null,
                "invoicingKind": 0,//0 单张开票 1 合并开票 2 拆分开票
                "address": '',
                "telephone": '',
                "openingBank": '',
                "openingBankAccount": '',
                "state": this.state,
            },
            "invoicingDetailList": [
                {
                    "duty": "",//税号
                    "id": null,
                    "invoicingId": null,
                    "lookUp": "",//发票抬头
                    "price": 0,//发票金额 要与所选择的 已支付的订单金额一致
                    "type": null,//0 企业 1 个人 2 非企业性单位
                    "remark": '',//备注
                }
            ],
            "invoicingDetailList1": [
                {
                    "duty": "",//税号
                    "id": null,
                    "invoicingId": null,
                    "lookUp": "",//发票抬头
                    "price": 0,//发票金额 要与所选择的 已支付的订单金额一致
                    "type": null,//0 企业 1 个人 2 非企业性单位
                    "remark": '',//备注
                },
            ],
            spreadDatas: {},//选中传过来的数据
            rules: {
                invoicingPartyName: [
                    { required: true, message: '请输入发票方', trigger: 'blur' },
                ],
                invoicingContent: [
                    { required: true, message: '请输入发票内容', trigger: 'blur' },
                ],
                invoicingRemark: [
                    { required: true, message: '请输入发票内容', trigger: 'blur' },
                ],
                // type:[
                //      { required: true, message: '请选择发票类型', trigger: 'change' },
                // ],
                // lookUp:[
                //      { required: true, message: '请输入发票抬头', trigger: 'blur' },
                // ],
                email: [
                    { required: true, message: "请输入邮箱地址", trigger: "blur" },
                    // {
                    //     type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change']
                    // },
                ],
            },
            current: '单张开票',
            dialogVisible: false,
            invoiceTypeObj: {
                line1: {
                    lineList: ['', '增值税普通发票(电子)', '增值税普通发票(纸质)', '增值税专用发票(纸质)'],
                    sty: {
                        backgroundColor: '#FFDDD4',
                        color: '#dd5827',
                    }
                },
                line2: {
                    lineList: ['配送时间', '离店后1日', '离店后3-7日', '离店后10日'],
                },
                line3: {
                    lineList: ['费用', '免费', '￥10/积分2000', '￥10/积分2000'],
                }
            },
            options: [{
                value: '0',
                label: '企业'
            }, {
                value: '1',
                label: '个人'
            }, {
                value: '2',
                label: '非企业性单位'
            }],
            invoiceInfoBtn: ['单张开票', '合并开票', '拆分开票'],
            cardLineBtn: [
                {
                    name: '电子增值税普通发票',
                    name1: '(离店后1日内送达)',
                    code: '0',
                },
                {
                    name: ' 电子增值税专用发票',
                    name1: '',
                    code: '3',
                },
                // {
                //     name: '纸质增值税普通发票',
                //     name1: '(离店后3-7日内送达)',
                //     code: '1',
                // },
                // {
                //     name: '纸质增值税专用发票',
                //     name1: '(专票不支持合并拆分)',
                //     code: '2',
                // }
            ]
        }
    },
    watch: {},
    methods: {
        //已有发票信息数据
        selectInvoice(rows) {
            if (rows.length > 0) {
                let row = rows[0]
                this.ruleForm.email = row.email
                this.ruleForm.telephone = row.telephone
                this.ruleForm.address = row.address
                this.ruleForm.openingBank = row.openingBank
                this.ruleForm.openingBankAccount = row.openingBankAccount
                this.ruleForm.invoicingRemark = row.invoicingRemark
                this.invoicingDetailList[0].duty = row.duty
                this.invoicingDetailList[0].lookUp = row.lookUp
                // this.invoicingDetailList[0].price = row.invoicingPrice
                this.invoicingDetailList[0].type = String(row.invoicingType)
            }
        },
        getDatas() {
            this.loading = true
            new Api('user').selectPlanInvoice(this.planId).then(res => {
                if (res.status === 200) {
                    this.tableData = res.data
                }
            })
        },
        //选择已有发票信息
        selectInvoiceInfo() {
            this.$refs.thereIsAlreadyAnInvoicePopUpBox.open()
        },
        init(data) {
            this.planId = data.planId || this.$store.state.planId
            this.invoiceTypeSW()
            // this.queryCompanyInfo()//查询公司信息
            this.spreadDatas = data
            this.invoicingDetailList[0].price = this.spreadDatas.payPrice
            this.ruleForm.invoicingOrderPriceRequests = [{ orderId: data.orderMainId, price: data.invoicePrice }]
            this.dialogVisible = true
            this.getDatas()
        },
        //收货地址填写
        addressFilling() {
            this.$refs.ticketRecipientInfo.initClick(this.companyInfo)
        },
        //拆分金额
        setInvoiceClick(val) {
            console.log(val, '大撒打算打算的');
            this.invoicingDetailList1 = val
            this.ruleForm.invoicingDetailList = val
        },
        //选择已有收获地址
        selectAddress() {
            this.$refs.existingAddressPopup.initClick()
        },
        //选择的收获地址数据
        addressInfoClick(val) {
            this.addressInfo = val
            this.ruleForm.userAddressId = val.id
            console.log(this.addressInfo, val);
        },
        //选择订单弹框
        handlerSelectOrderClick() {
            this.state ? this.$refs.collectionSelectList.initClick(this.orderList, this.ruleForm.invoicingOrderPriceRequests) : this.$refs.orderSelectList.initClick(this.ruleForm.invoicingOrderPriceRequests)
        },
        //选择的订单数据
        orderClick(val, price) {
            this.allOrderPrice = price  //合并订单的总价格
            this.ruleForm.invoicingOrderPriceRequests = val
        },
        //设置发票
        handlerSetOrderInvoiceClick() {
            let obj = {
                lookUp: this.companyInfo,
                orderPrice: parseFloat(this.spreadDatas.payPrice).toFixed(2)
            }
            let arr = JSON.parse(JSON.stringify(this.ruleForm.invoicingDetailList))
            this.$refs.setInvoicePopup.initClick(obj, arr)
        },
        //发票类型切换
        invoiceTypeSW() {
            let arr = [
                {
                    name: '电子增值税普通发票',
                    name1: '(离店后1日内送达)',
                    code: '0',
                },
                // {
                //     name: '纸质增值税普通发票',
                //     name1: '(离店后3-7日内送达)',
                //     code: '1',
                // },
                // {
                //     name: '纸质增值税专用发票',
                //     name1: '(专票不支持合并拆分)',
                //     code: '2',
                // }
            ]
            // ========可能得修改===========
            // if (this.current === '单张开票') {
            //     this.cardLineBtn = arr
            // } else {
            //     this.cardLineBtn = arr.filter(n => n.code != 2)
            // }
            if (this.current === '合并开票') {
                this.allOrderPrice = this.spreadDatas.payPrice
            }
            if (this.current == '拆分开票') {
                this.ruleForm.invoicingDetailList = this.invoicingDetailList1
            } else {
                this.ruleForm.invoicingDetailList = this.invoicingDetailList
            }
        },
        //关闭弹框清除内容及交验
        close() {
            this.$refs['ruleForm'].resetFields();
        },
        //查询公司信息
        queryCompanyInfo() {
            new Api("user")
                .queryCompanyInfo()
                .then((res) => {
                    if (res.status == 200) {
                        this.companyInfo = res.data.lookUp
                        this.invoicingDetailList[0].lookUp = res.data.lookUp
                        this.invoicingDetailList1[0].lookUp = res.data.lookUp
                        // this.invoicingDetailList1.forEach(item => {
                        //     item.lookUp = res.data.lookUp
                        // })
                    } else {
                        this.$message.error({ message: res.statusText });
                    }
                });
        },
        submitForm(formName) {
            // 防止重复提交
            if (this.isSubmitting) {
                this.$message.warning({ message: "正在提交，请稍等..." });
                return;
            }
            this.isSubmitting = true;
            
            let obj = JSON.parse(JSON.stringify(this.ruleForm))
            //如果是单张开票或拆分开并且invoicingType == 0票需要把选中的那条数据的主订单id放进去,并且没有配送信息
            if (this.current !== '合并开票') {
                let arr = [{ orderId: this.spreadDatas.orderMainId, price: this.spreadDatas.invoicePrice }]
                obj.invoicingOrderPriceRequests = arr
            }
            //如果invoicingType == 0没有配送信息
            if (obj.invoicingType == 0) {
                obj.userAddressId = null
            }
            //如果是单张开票或合并开票需要把金额设置进去 
            if (this.current === '单张开票') {
                obj.invoicingDetailList[0].price = this.spreadDatas.payPrice
            }
            if (this.current === '合并开票') {
                obj.invoicingDetailList[0].price = this.allOrderPrice ? this.allOrderPrice : this.spreadDatas.payPrice
            }
            if (this.current === '拆分开票' && obj.invoicingDetailList.length == 1 && !obj.invoicingDetailList[0].price) {
                obj.invoicingDetailList[0].price = this.spreadDatas.payPrice
            }
            if (obj.invoicingType != 0 && !this.ruleForm.userAddressId) {
                this.$message.warning({ message: '请选择收票人信息' })
            } else {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        new Api("user")
                            .addInvoice(obj)
                            .then((res) => {
                                if (res.status == 200) {
                                    this.dialogVisible = false
                                    this.$emit('update', this.detailId) //更新主列表数据
                                    this.$message.success({ message: '发票新增成功！' });
                                } else {
                                    this.$message.error({ message: res.statusText });
                                }
                            });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            }
            
            // 在提交完成后或出错时重置状态
            setTimeout(() => {
                this.isSubmitting = false;
            }, 3000);
        },
    },
    created() {

    },
    mounted() {
    },
}
</script>
<style lang='scss' scoped>
/deep/ .el-form-item__error {
    white-space: nowrap;
}

/deep/ .el-form-item__label {
    white-space: nowrap;
}

.container {
    margin: 0.5rem;

    .addressInfoBox {
        li {
            margin-bottom: 0.1rem;
            display: flex;
            align-items: center;

            p {
                width: 70px;
                text-align: right;
            }

            &:nth-last-child(1) {
                margin-bottom: 0;
            }
        }
    }

    .active {
        color: #57a4f2 !important;
    }

    .active1 {
        color: #DF552D !important;
        border-color: #DF552D !important;
        transition: all 0.5s ease;
    }

    .lineBox {
        margin-bottom: 0.2rem;

        .lineBoxTitle {
            display: flex;
            align-items: center;
            margin-bottom: 0.2rem;

            .fengGe {
                height: 0.2.4rem;
                width: 3px;
                background-color: #DF552D;
                margin-right: 0.2rem;
            }

            .p1 {
                font-weight: bold;
                font-size: 0.22rem;
                margin-right: 0.2rem;
            }

            .p2 {
                color: #DF552D;
                font-weight: bolder;
            }

            .p3 {
                margin-right: 0.25rem;
                cursor: pointer;

                &:hover {
                    text-decoration: underline;
                }
            }
        }

        .lineBoxP1 {
            margin-bottom: 0.1rem;

            &:nth-last-child(1) {
                margin-bottom: 0;
            }

            .lineBoxSpan1 {
                color: red;
                margin-right: 0.05rem;
            }

            .lineBoxSpan2 {
                font-weight: bold;
            }
        }

        .invoice {
            display: flex;
            width: 8rem;

            &:nth-last-child(1) {
                border-bottom: 1px solid #ddd;

                .invoiceBox {
                    &:nth-child(2) {
                        color: #DF552D;
                        font-weight: bold;
                    }
                }
            }

            .invoiceBox {
                width: 2rem;
                height: 0.5rem;
                border-top: 1px solid #ddd;
                display: flex;
                align-items: center;
                justify-content: center;

                &:nth-child(1) {
                    color: #b7b7b7;
                }

                &:nth-child(odd) {
                    border-right: 1px solid #ddd;
                    border-left: 1px solid #ddd;
                }

                &:nth-last-child(1) {
                    border-right: 1px solid #ddd;
                }
            }
        }

        .cardLine {
            display: flex;
            align-items: center;
            margin-bottom: 0.15rem;

            .cardLineP1 {
                width: 90px;
                text-align: right;
                color: #606266;
                white-space: nowrap;

                span {
                    color: red;
                    margin-right: 0.05rem;
                }
            }

            .cardLineP2 {
                color: #57a4f2;
                cursor: pointer;
                text-decoration: underline;
            }

            .infoBox {
                cursor: pointer;
                height: 0.6rem;
                padding: 0 0.2rem;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                color: #aaa;
                border: 1px solid #ccc;
                margin-right: 0.2rem;
            }

            .locationBox {
                width: 2rem;
                height: 1rem;
                border: 1px dotted #ddd;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                cursor: pointer;

                .locationBoxP1 {
                    color: #aaa;
                }
            }

            .priceBtn {
                line-height: 0.32rem;
                height: 0.32rem;
                border: 1px solid red;
                padding: 0 0.2rem;
                margin-right: 0.2rem;
                border-radius: 3px;

                .priceBtnSpan1 {
                    margin-right: 0.05rem;
                }

                .priceBtnSpan2 {
                    color: #dd5859;
                }
            }

        }
    }
}
</style>